module.exports = __webpack_public_path__ + "assets/font/SourceHanSansTWHK-Normal-79a76099.ttf";